module.exports = __webpack_public_path__ + "img/icon5.f058d502.png";